import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareChecklist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareChecklist"><Path d="M7.54297 8.99775L8.66797 9.74775L10.5396 7.25224M13.558 8.5H16.558M13.5 15.5H16.5M7.54297 15.7489L8.66797 16.4989L10.5396 14.0034M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareChecklist;
